var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EA380AB8-B447-47B9-AB08-14C1C5A7DD8E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 16.998V0h16.999v16.998z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.281
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .25)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0a8.5 8.5 0 1 1 0 17 8.5 8.5 0 0 1 0-17",
    fill: "#27333F",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.96 3.148v1.805h1.802v9.399H4.238V3.148h6.723"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E9EA",
    d: "M10.96 3.148l1.802 1.805H10.96V3.148"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8CD1E9",
    d: "M5.15 9.688h6.7v-.5h-6.7zM5.15 8.627h6.7v-.5h-6.7zM5.15 7.563h6.7v-.5h-6.7zM5.15 10.748h6.7v-.5h-6.7zM5.15 11.808h6.7v-.5h-6.7zM5.15 12.869h3.158v-.5H5.15z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.ad72c5da44f40426f07915488531a6b4.svg";
export { ForwardRef as ReactComponent };